export default class GridMap {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`)
        return {
            size: this.size,
            width: this.width,
            height: this.height,
            mapData: Array.from(this.map.entries()), // Convert Map to array for JSON
        };
    }

    static deserialize(data) {
        const gridMap = new GridMap(data.size, data.width, data.height);
        // Restore the map data
        if (data.mapData) {
            gridMap.map = new Map(data.mapData);
        }
        return gridMap;
    }

    constructor(size = 16, width, height) {
        this.map = new Map();
        this.size = size; // grid size for each dimension
        this.width = width;
        this.height = height;
    }

    // Serializes the coordinates to use as a key
    _serializeKey(x, y) {
        return JSON.stringify({ x, y });
    }

    widthInPixels() {
        return this.width * this.size;
    }

    heightInPixels() {
        return this.height * this.size;
    }

    // Calculates grid positions and adds an object to those positions
    add(x, y, value) {
        console.log(x, y, value);
        const positions = this._calculatePositions(x, y);
        if (positions.length > 2) {
            console.warn(`Warning: Adding '${value}' to more than two positions.`);
        }
        console.log(positions);
        positions.forEach((pos) => {
            console.log('adding collision...');
            const key = this._serializeKey(pos.x, pos.y);
            console.log(key);
            if (!this.map.has(key)) {
                this.map.set(key, []);
            }
            if (!this.map.get(key).includes(value)) {
                this.map.get(key).push(value);
            }
        });
    }

    // Calculates all valid grid positions for given coordinates
    _calculatePositions(x, y) {
        const positions = [];
        const xStart = Math.floor(x / this.size) * this.size + 1;
        const xEnd = Math.ceil(x / this.size) * this.size;
        const yStart = Math.floor(y / this.size) * this.size + 1;
        const yEnd = Math.ceil(y / this.size) * this.size;

        for (let posX = xStart; posX <= xEnd; posX += this.size) {
            for (let posY = yStart; posY <= yEnd; posY += this.size) {
                positions.push({ x: posX, y: posY });
            }
        }

        return positions;
    }

    // Retrieves all objects at the specified position
    get(x, y) {
        const key = this._serializeKey(x, y);
        return this.map.get(key)?.length > 0 ? this.map.get(key)[0] : false;
    }

    // Sets (overrides) the objects at a specific position
    set(x, y, value) {
        const key = this._serializeKey(x, y);
        this.map.set(key, [value]);
    }

    // Checks if there are any objects at the specified position
    has(x, y) {
        const key = this._serializeKey(x, y);
        return this.map.has(key) && this.map.get(key).length > 0;
    }

    // Removes an object at the specified position, can also remove specific objects if needed
    delete(x, y, value = null) {
        const key = this._serializeKey(x, y);
        if (value === null) {
            return this.map.delete(key);
        } else {
            const items = this.map.get(key);
            if (items) {
                const index = items.indexOf(value);
                if (index > -1) {
                    items.splice(index, 1);
                    return true;
                }
            }
            return false;
        }
    }

    // Clears all entries from the map
    clear() {
        this.map.clear();
    }
}
